export default "__VITE_ASSET__BHgUJr6f__"